// extracted by mini-css-extract-plugin
export default {"meal":"RenderVegList_meal__UsfNo","description":"RenderVegList_description__KMpSA","price":"RenderVegList_price__IkBrA"};